import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import "./ProductCreate.css";

function ProductCreate({ products, setProducts }) {
  const [categories, setCategories] = useState();
  const admin = useSelector((state) => state.admin);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      title: "",
      color: "",
      description: "",
      stock: "",
      highlight: "",
      category: "",
      price: 0,
      slug: "",
    },
  });

  useEffect(() => {
    getProductCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getProducts = async () => {
    try {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}/products`,
        headers: { Authorization: `Bearer ${admin.token}` },
      });

      data && setProducts((products = [...data]));
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  //Promise toastify
  let promiseToastify = (exito) => {
    const resolveAfter2sec = new Promise((resolve, reject) => {
      setTimeout(() => {
        exito ? resolve() : reject();
        reset();
      }, 2000);
    });
    toast.promise(resolveAfter2sec, {
      pending: "Loading...",
      success: "Successfully registered",
      error: "Error!",
    });
  };
  //Ajax call
  async function onSubmit(data) {
    try {
      let {
        description,
        color,
        title,
        name,
        stock,
        highlight,
        price,
        slug,
        category,
      } = data;
      highlight === "true" ? (highlight = true) : (highlight = false);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/products`,

        {
          name,
          title,
          price: Number(price),
          color,
          description,
          stock: Number(stock),
          slug,
          highlight,
          categories: { _id: category },
        },
        { headers: { Authorization: `Bearer ${admin.token}` } }
      );

      if (response.status === 200) {
        getProducts();
        promiseToastify(true);
      }
    } catch (error) {
      promiseToastify(false);
      console.log(error);
    }
  }
  async function getProductCategories() {
    try {
      const { data: categories } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}/categories`,
        headers: { Authorization: `Bearer ${admin.token}` },
      });
      setCategories(categories);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="Register mb-5 ">
      <h1 className="text-center mb-4 p-5 fs-1">NEW PRODUCT</h1>
      <div className="">
        <form className="w-100" onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4 input-container">
            <label
              htmlFor="name"
              className="d-flex justify-content-between mb-2 align-items-end"
            >
              Name :<span className="required">REQUIRED</span>
            </label>
            <input
              type="text"
              id="name"
              {...register("name", {
                required: { value: true, message: "Field required" },
                minLength: { value: 5, message: "Min lenght of 5" },
                maxLength: 50,
              })}
              className={errors.name && "input-border-error"}
            />
            {errors.name && (
              <span className="text-danger">{errors.name.message}</span>
            )}
          </div>
          <div className="mb-4 input-container">
            <label
              htmlFor="title"
              className="d-flex justify-content-between mb-2 align-items-end"
            >
              Title :<span className="required">REQUIRED</span>
            </label>
            <input
              type="text"
              id="title"
              {...register("title", {
                required: { value: true, message: "Field required" },
                minLength: { value: 2, message: "Min lenght of two" },
                maxLength: 50,
              })}
              className={errors.title && "input-border-error"}
            />
            {errors.title && (
              <span className="text-danger">{errors.title.message}</span>
            )}
          </div>
          <div className="mb-4 input-container">
            <label
              htmlFor="price"
              className="d-flex justify-content-between mb-2 align-items-end"
            >
              Price: <span className="required">REQUIRED</span>
            </label>
            <input
              type="number"
              id="price"
              {...register("price", {
                required: { value: true, message: "Field required" },
              })}
            />
          </div>
          <div className="mb-4 input-container">
            <label
              htmlFor="color"
              className="d-flex justify-content-between mb-2 align-items-end"
            >
              Color :<span className="required">REQUIRED</span>
            </label>
            <input
              type="text"
              id="color"
              className={errors.color && "input-border-error"}
              {...register("color", {
                required: { value: true, message: "Field required" },
              })}
            />
            {errors.color && (
              <span className="text-danger">{errors.color.message}</span>
            )}
          </div>
          <div className="mb-4 input-container">
            <label
              htmlFor="description"
              className="d-flex justify-content-between mb-2 align-items-end"
            >
              Description :
            </label>
            <input type="text" id="description" {...register("description")} />
          </div>
          <div className="mb-4 input-container">
            <label htmlFor="category">Category</label>
            <select
              id="category"
              className="form-select form-select-lg mb-3"
              aria-label=".form-select-lg example"
              {...register("category")}
            >
              {categories &&
                categories.map((category) => (
                  <option value={category._id}>{category.title}</option>
                ))}
            </select>
          </div>
          <div className="mb-4 input-container">
            <label
              htmlFor="stock"
              className="d-flex justify-content-between mb-2 align-items-end"
            >
              Stock:
            </label>
            <input
              type="number"
              id="stock"
              {...register("stock", {
                required: { value: true, message: "Field required" },
              })}
            />
          </div>
          <div className="mb-4 input-container">
            <label
              htmlFor="slug"
              className="d-flex justify-content-between mb-2 align-items-end"
            >
              Slug :
            </label>
            <input type="text" id="slug" {...register("slug")} />
          </div>
          <div className="mb-4 input-container">
            <label htmlFor="highlight">Highlight</label>
            <select
              id="highlight"
              className="form-select form-select-lg mb-3"
              aria-label=".form-select-lg example"
              {...register("highlight")}
            >
              <option key="true" value={true}>
                Yes
              </option>
              <option key="false" value={false}>
                No
              </option>
            </select>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-center  ">
            <div className="d-flex align-items-center justify-content-center">
              <button
                className="btn btn-three d-flex align-items-center justify-content-center text-white w-100"
                id="btn-register"
                type="submit"
              >
                Create Product
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProductCreate;
